import { create } from 'zustand';

/** In-memory only — cleared on page refresh (no localStorage). */
interface AdminState {
  sessionUnlocked: boolean;
  setSessionUnlocked: (value: boolean) => void;
  clearSession: () => void;
}

export const useAdminStore = create<AdminState>((set) => ({
  sessionUnlocked: false,
  setSessionUnlocked: (value) => set({ sessionUnlocked: value }),
  clearSession: () => set({ sessionUnlocked: false })
}));
